import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import Icon from 'vibo-ui/Icon';
import Button from 'vibo-ui/Button';

import { ReactComponent as ViboWelcomeSplash_1 } from 'resources/img/svg/viboWelcomeSplash_1.svg';
import { ReactComponent as ViboWelcomeSplash_2 } from 'resources/img/svg/viboWelcomeSplash_2.svg';

import useStyles from './style';

// export const useViboWelcome = () => {

//   return {
//     start: () => {
//       const container = document.createElement('div');
//       container.id = 'test';
//       document.body.appendChild(container);
//       const root = createRoot(container);

//       root.render(<ViboWelcome />);
//     },
//   };
// };

const ViboWelcome: FC = () => {
  const classes = useStyles();

  const [cancel, setCancel] = useState(false);

  const navigate = useNavigate();

  return (
    <div
      className={classNames(classes.viboWelcome, {
        cancel,
      })}
    >
      <Icon icon={ViboWelcomeSplash_1} className="logo" />
      <Icon icon={ViboWelcomeSplash_2} className="text" />
      <Button
        onClick={() => {
          setCancel(true);

          const t = setTimeout(() => {
            const gg = document.getElementById('test');
            gg?.remove();
            navigate('/templates/user');
            clearTimeout(t);
          }, 700);
        }}
        displayType="primary"
        shape="round"
        size="lg"
      >
        Let's get started
      </Button>
    </div>
  );
};

export default ViboWelcome;
